import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import * as dashboardService from "../services/dashboard.services";
import { useTranslation } from "react-i18next";
import Loader from "../common/loader";
import Sorting from "../common/sorting";
import { capitalizeFirstLetter, formateDateWithMonth } from "../../../utils/commonfunction";
import CustomPagination from "../common/custompagination";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { LOADER_TIMEOUT_TIME } from "../../../utils/Constants";

const Dashboard = () => {
  const [showDashboardCount, setShowDashboardCount] = useState({});
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [featuredStatsupdate, setFeaturedStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");

  const superAdminRaw = localStorage.getItem("super_admin");
  const staffDataNew = superAdminRaw ? JSON.parse(superAdminRaw) : null;

  const { t } = useTranslation();

  useEffect(() => {
    dashboardService
      .Counts()
      .then((response) => {
        setShowDashboardCount(response && response.data ? response.data : {});
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  }, []);

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);

        dashboardService
          .recentEarningList(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            // setSerialNo(data.data.offset);
            setList(data && data.data && data.data.list ? data.data.list : []);
            //   console.log("data.data.data_ids", data.data.data_ids);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
            setLoader(false);
          });
      }
    }, 500);
    return () => clearTimeout(getData)
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);

  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    // setResetDate(!resetdate);
    // $("#defaultstatus")[0].selectedIndex = 0;
  };

  return (
    <>
      <div className="row row-sm animation_fade">
        <div className="col-sm-12 col-lg-12 col-xl-12">
          <div className="row row-sm">
            {staffDataNew.role === "super_admin" ?
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <div className="card custom-card">
                <div className="card-body cp">
                  <Link to={`/admin/dashboard/1`}>
                    <div className="card-item">
                      <div className="card-item-icon card-icon cp ">
                        <i className="fa fa-money-bill sidemenu-icon" style={{ fontSize: "20px" }}></i>
                      </div>
                      <div className="card-item-title mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">
                          {/* { t("admin.dashboard.dashboard_link_cafes")} */}
                          Total Commission
                        </label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h4 className="font-weight-bold">
                            {showDashboardCount && showDashboardCount.totalCommission
                              ? '₹' + ' ' + (showDashboardCount.totalCommission).toFixed(2)
                              : "₹0.00"}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div> : null}
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <div className="card custom-card">
                <div className="card-body cp">
                  <Link to={`/admin/center-management/center/list/1`}>
                    <div className="card-item">
                      <div className="card-item-icon card-icon cp ">
                        {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          className="bi bi-people-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
                        </svg> */}
                        {/* <i className="fa fa-coffee" style={{fontSize:"20px"}}></i> */}
                        <i className="fa fa-building sidemenu-icon" style={{ fontSize: "20px" }}></i>
                      </div>
                      <div className="card-item-title mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">
                          {/* { t("admin.dashboard.dashboard_link_cafes")} */}
                          Total Centers
                        </label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h4 className="font-weight-bold">
                            {showDashboardCount && showDashboardCount.users
                              ? showDashboardCount.users
                              : "0"}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <div className="card custom-card">
                <div className="card-body cp">
                  <Link to={`/admin/doctor-management/doctor/list/1`}>
                    <div className="card-item">
                      <div className="card-item-icon card-icon cp ">
                        {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          className="bi bi-people-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
                        </svg> */}
                        {/* <i className="fa fa-coffee" style={{fontSize:"20px"}}></i> */}
                        <i className="fa fa-user-md sidemenu-icon" style={{ fontSize: "20px" }}></i>
                      </div>
                      <div className="card-item-title mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">
                          {/* { t("admin.dashboard.dashboard_link_cafes")} */}
                          Total Doctors
                        </label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h4 className="font-weight-bold">
                            {showDashboardCount && showDashboardCount.doctors
                              ? showDashboardCount.doctors
                              : "0"}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <div className="card custom-card">
                <div className="card-body cp">
                  <Link to={`/admin/patient-management/patient/list/1`}>
                    <div className="card-item">
                      <div className="card-item-icon card-icon cp ">
                        {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          className="bi bi-people-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
                        </svg> */}
                        {/* <i className="fa fa-coffee" style={{fontSize:"20px"}}></i> */}
                        <i className="fa fa-user sidemenu-icon" style={{ fontSize: "20px" }}></i>
                      </div>
                      <div className="card-item-title mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">
                          {/* { t("admin.dashboard.dashboard_link_cafes")} */}
                          Total Patients
                        </label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h4 className="font-weight-bold">
                            {showDashboardCount && showDashboardCount.patients
                              ? showDashboardCount.patients
                              : "0"}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <div className="card custom-card">
                <div className="card-body cp">
                  <Link to={`/admin/appointment/list/1`}>
                    <div className="card-item">
                      <div className="card-item-icon card-icon cp ">
                        {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24"
                          className="bi bi-people-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216ZM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
                        </svg> */}
                        {/* <i className="fa fa-coffee" style={{fontSize:"20px"}}></i> */}
                        <i className="fa fa-calendar sidemenu-icon" style={{ fontSize: "20px" }}></i>
                      </div>
                      <div className="card-item-title mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">
                          {/* { t("admin.dashboard.dashboard_link_cafes")} */}
                          Total Appointments
                        </label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h4 className="font-weight-bold">
                            {showDashboardCount && showDashboardCount.appointments
                              ? showDashboardCount.appointments
                              : "0"}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="main-content-label">
                  Recent Earnings
                </h6>
                <div className="d-flex align-items-center">
                  <div className="form-group mb-0 me-3">
                    <div className="form-group mb-0 rangepicker_container filter_design">
                      <i className="fa fa-search calender_icon"></i>
                      <input
                        type="search"
                        className="form-control"
                        value={globalsearch}
                        placeholder={t("admin.filter_placeholder.input_placeholder_search")}
                        onChange={(e) => {
                          setGlobalSearch(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                  {/* <div className="me-3">
                    <CustomRangepicker
                      GetDateRange={(e) => {
                        prepareSearch("createdAt", e);
                      }}
                      resetdate={resetdate}
                    />
                  </div>
                  <div className="me-3">
                    <StatusFilter
                      data={showFilterlistNew}
                      prepareSearch={prepareSearch}
                    />
                  </div> */}
                  <button
                    type="reset"
                    value="Reset"
                    onClick={resetFilter}
                    className="btn btn-warning float-right mr-2"
                  >
                    {t("admin.filter_placeholder.btn_reset_filter")}
                  </button>
                </div>
              </div>
              <div className="table-responsive">
                <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                  <thead>
                    <tr>
                      {/* <th>
                        <div className="sorting_column">
                          <span>{t("Medicine ID")}</span>
                          <Sorting
                            sort={sorting}
                            // handleSort={handleSort}
                            column="medicine_id"
                          />
                        </div>
                      </th> */}
                      <th>Transaction ID</th>
                      <th>Center Name</th>
                      <th>Center Register ID</th>
                      <th>Amount</th>
                      <th className="">{t("Transaction Type")}</th>
                      {/* <th className="status_head">{t("admin.list_heading.list_heading_status")}</th>
                      <th className="action_head">{t("admin.list_heading.list_heading_action")}</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {loader ? (
                      <tr>
                        <td colSpan={14}>
                          <Loader />
                        </td>
                      </tr>
                    ) : (
                      <>
                        {list.length ? (
                          list.map((row, i) => {
                            return (
                              <tr
                                key={i}
                              >
                                <td>{row?.transaction_id ? (row?.transaction_id) : '-'}</td>
                                <td>{capitalizeFirstLetter(row?.center_name)}</td>
                                <td>{(row?.center_register_id ? '#' + (row?.center_register_id) : '-')}</td>
                                <td>{row?.amount ? '₹' + ' ' + (row?.amount.toFixed(2)) : '0.00'}</td>
                                <td>{capitalizeFirstLetter(row?.transaction_type)}</td>
                                {/* <td>{row?.total_doctors}</td> */}
                                {/* <td>
                                  {row?.name ? (
                                    <div className="d-flex">
                                      {row?.name ? capitalizeFirstLetter(row.name) : "N/A"}
                                    </div>
                                  ) : (
                                    <div className="d-flex">N/A</div>
                                  )}
                                </td> */}
                                {/* <td>{row?.quantity ? row.quantity : "N/A"}</td> */}
                                {/* <td>
                                  {row.createdAt
                                    ? formateDateWithMonth(row.createdAt)
                                    : "N/A"}
                                </td> */}
                                {/* <td>
                                    {row.status === 1 ? (
                                      <button
                                        className="btn ripple btn-main-primary signbtn"
                                        onClick={() => {
                                          // ChangeStatus(row?._id, 0);
                                        }}
                                      >
                                      Available
                                      </button>
                                    ) : (
                                      <button
                                        className="btn ripple btn-secondary"
                                        onClick={() => {
                                          // ChangeStatus(row?._id, 1);
                                        }}
                                      >
                                      Unavailable
                                      </button>
                                    )}
                                </td> */}
                                {/* <td>
                                  <div className="d-flex">
                                    <button
                                      className="btn ripple btn-main-primary signbtn"
                                      onClick={() => {
                                        // viewfunction(row);
                                      }}
                                    >
                                      {t("admin.button.btn_view")}
                                    </button>

                                    <button
                                      className="btn ripple btn-success mlAction"
                                      onClick={() => {
                                        // goToEdit(row);
                                      }}
                                    >
                                      {t("admin.button.btn_edit")}
                                    </button>
                                    
                                    <div className="btn-group mlAction">
                                      <button
                                        type="button"
                                        className="btn btn-dark dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        {t("admin.button.btn_more")}
                                      </button>
                                      <ul className="dropdown-menu">
                                        <li>
                                          <button
                                            className="dropdown-item"
                                            onClick={() => {
                                              // Deletefunction(row?._id, row?.email);
                                            }}
                                          >
                                            {t("admin.button.btn_delete")}
                                          </button>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </td> 
                              */}
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={14} className="text-center">
                              {t("admin.message.msg_no_records")}
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
              <div
                className=""
                id="example1_info"
                role="status"
                aria-live="polite"
              >
                <b>
                  {t("admin.message.msg_total_records")} : {datalength ? datalength : "0"}
                </b>
              </div>
              {datalength && datalength > 0 ? (
                <CustomPagination
                  datalength={datalength}
                  itemperpage={itemperpage}
                  currentPage={page}
                  setPage={setPage}
                  pageRoute={[
                    {
                      name: "Medicine Management",
                      path: "/admin/dashboard",
                    },
                  ]}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
